import React, { useState, useEffect } from 'react';
import { PropTypes } from 'prop-types';
import Multiselect from './Multiselect';
import DoneIcon from '../../../../../assets/images/iconsV2/done.svg';
import Icon from '../../Icons/Icon';

export default {
  title: 'Components/Inputs/Multiselect',
  component: Multiselect,
  parameters: {
    layout: 'centered',
  },
  tags: ['autodocs'],
};

const MultiselectTemplate = ({ label, values }) => {
  const [options, setOptions] = useState(values);
  const [selectAllState, setSelectAllState] = useState('none');

  const updateSelectAllState = (updatedOptions) => {
    const selectedCount = updatedOptions.filter(option => option.selected).length;
    if (selectedCount === updatedOptions.length && updatedOptions.length > 0) {
      setSelectAllState('checked');
    } else if (selectedCount > 0) {
      setSelectAllState('indeterminate');
    } else {
      setSelectAllState('none');
    }
  };

  useEffect(() => {
    updateSelectAllState(options);
  }, [options]);

  const handleSelectAll = () => {
    const updatedOptions = options.map(option => ({
      ...option,
      selected: selectAllState !== 'checked',
    }));
    setOptions(updatedOptions);
    updateSelectAllState(updatedOptions);
  };

  return (
    <div>
      {/* Select all */}
      <button type="button" className="flex items-center text-medium text-vamos-black" onClick={handleSelectAll}>
        <div
          className={`w-5.5 h-5.5 flex items-center justify-center rounded mr-3
          ${selectAllState === 'checked' ? 'bg-vamos-black border border-vamos-black' : ''}
          ${selectAllState === 'indeterminate' ? 'border border-vamos-black bg-vamos-white' : ''}
          ${selectAllState === 'none' ? 'border border-vamos-blue-gray bg-vamos-white' : ''}`}
        >
          {selectAllState === 'checked' && <img src={DoneIcon} alt="Checked" className="w-5.5 h-5.5" />}
          {selectAllState === 'indeterminate' && (
            <Icon name="check_indeterminate_small" className="w-5 h-5" />
          )}
        </div>
        Select all
      </button>

      {/* Multiselect */}
      <Multiselect label={label} options={options} setValue={setOptions} />
    </div>
  );
};

const Template = MultiselectTemplate.bind({});

export const Default = Template.bind({});
Default.args = {
  label: 'Multiselect',
  values: [
    { label: 'A', value: 'a', selected: false },
    { label: 'B', value: 'b', selected: false },
    { label: 'C', value: 'c', selected: false },
  ],
};

export const SavedValues = Template.bind({});
SavedValues.args = {
  label: 'Multiselect',
  values: [
    { label: 'A', value: 'a', selected: false },
    { label: 'B', value: 'b', selected: true },
    { label: 'C', value: 'c', selected: false },
  ],
};

export const SavedAllValues = Template.bind({});
SavedAllValues.args = {
  label: 'Multiselect',
  values: [
    { label: 'A', value: 'a', selected: true },
    { label: 'B', value: 'b', selected: true },
    { label: 'C', value: 'c', selected: true },
  ],
};

MultiselectTemplate.propTypes = {
  label: PropTypes.string,
  values: PropTypes.array.isRequired,
};
